import React from 'react';
import PropTypes from 'prop-types';

// Components
import FacebookButton from './SocialButtons/FacebookButton';
import LinkedInButton from './SocialButtons/LinkedInButton';
import PinterestButton from './SocialButtons/PinterestButton';
import TwitterButton from './SocialButtons/TwitterButton';
// Style
import './social-buttons.scss';

const ShareButtonGroup = ({ url, title, summary }) => (
  <div className="flex flex-column">
    <div className="social-button-group">
      <h6 className="social-group-title text-center text-md-left text-sm-center text-xs-center">
        Share
      </h6>
      <div className="flex column-lg row-xs center-xs flex-wrap mt-1 flex-middle">
        <FacebookButton postLink={url} title={title} />
        <TwitterButton postLink={url} title={title} />
        <LinkedInButton postLink={url} title={title} summary={summary} />
        <PinterestButton postLink={url} title={title} />
      </div>
    </div>
  </div>
);

ShareButtonGroup.defaultProps = {
  url: '',
  title: '',
  summary: '',
};

ShareButtonGroup.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  summary: PropTypes.string,
};

export default ShareButtonGroup;
